import React from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { Divider, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComments } from '@fortawesome/free-solid-svg-icons'

import { storeClickLog } from '../containers/ClickLogs/services'
import { handleError } from '../helpers'

const getWhatsappNumber = customer => {
	if (customer.mobile && customer.mobile.toString().length === 10) {
		return customer.mobile
	}
	return customer.phone
}

const hasWhatsappNumber = customer => {
	const hasMobile = customer.mobile && customer.mobile.toString().length === 10
	const hasPhone = customer.phone && customer.phone.toString().length === 10
	return hasMobile || hasPhone
}

export default function WhatsappButton({ customer, invoiceId, reload, disabled }) {
	const currentUser = useSelector(state => state.auth.user)

	if (!hasWhatsappNumber(customer)) return null

	const handleClick = () => {
		const payload = {
			user_id: currentUser.id,
			customer_id: customer.id,
			type: 'whatsapp'
		}

		if (invoiceId) payload.invoice_id = invoiceId

		storeClickLog(payload)
			.then(() => {
				reload()
				window.open(`https://wa.me/57${getWhatsappNumber(customer)}?text=`)
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Tooltip title="Whatsapp">
				<Button
					size='sm'
					color={disabled ? 'dark' : 'primary'}
					disabled={disabled}
					outline
					onClick={handleClick}
				>
					<FontAwesomeIcon icon={faComments} />
				</Button>
			</Tooltip>
			<Divider type='vertical' />
		</React.Fragment>
	)
}
